
import AppLoadingScreen from './AppLoadingScreen';

export default {
  name: 'AppAjaxContent',
  components: { AppLoadingScreen },
  props: {
    isLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      isReady: !this.isLoading,
      screenWidth: 0
    };
  },
  watch: {
    isLoading() {
      if (this.isLoading) {
        this.setLoadingScreenWidth();
      } else {
        this.isReady = true;
        // Wait until the slot is rendered
        this.$nextTick(() => this.$emit('ready'));
      }
    }
  },
  methods: {
    setLoadingScreenWidth() {
      if (getComputedStyle(this.$el).display === 'none') return;
      this.$el.style.setProperty('display', 'inline-block');
      this.$el.style.setProperty('min-width', '100%');
      this.screenWidth = `${this.$el.offsetWidth}px`;
      this.$el.style.setProperty('display', '');
      this.$el.style.setProperty('min-width', '');
    }
  }
};
